/**
 * ChecklistTemplate API Contract
 *
 * Mirrors: backend/src/routes/checklistTemplate.routes.ts
 * 1:1 parity with existing Express routes
 *
 * SECURITY: companyId comes from JWT context, never from request
 */
import { oc } from "@orpc/contract";
import { z } from "zod";
import { CreateChecklistTemplateInputSchema, UpdateChecklistTemplateInputSchema, ChecklistTemplateResponseSchema, } from "@hourly/api/checklistTemplate";
// ===== CONTRACTS =====
/**
 * POST /checklist-templates
 * Create a new checklist template
 *
 * Express: POST /api/checklist-templates
 * Security: companyId injected from JWT context
 */
export const createChecklistTemplate = oc
    .route({
    method: "POST",
    path: "/checklist-templates",
    summary: "Create a new checklist template",
    tags: ["ChecklistTemplates"],
    successStatus: 201,
})
    .input(CreateChecklistTemplateInputSchema)
    .output(ChecklistTemplateResponseSchema);
/**
 * GET /checklist-templates/{id}
 * Get a checklist template by ID
 *
 * Express: GET /api/checklist-templates/:id
 */
export const getChecklistTemplate = oc
    .route({
    method: "GET",
    path: "/checklist-templates/{id}",
    summary: "Get checklist template by ID",
    tags: ["ChecklistTemplates"],
})
    .input(z.object({ id: z.uuid() }))
    .output(ChecklistTemplateResponseSchema);
/**
 * GET /checklist-templates
 * List checklist templates for the authenticated user's company
 *
 * Express: GET /api/checklist-templates/companies/:companyId
 * Security: companyId comes from JWT, not path param
 *
 * Query params:
 * - locationId (optional): Filter by location
 */
export const getChecklistTemplates = oc
    .route({
    method: "GET",
    path: "/checklist-templates",
    summary: "List checklist templates for company",
    tags: ["ChecklistTemplates"],
})
    .input(z.object({
    locationId: z.uuid().optional(),
}))
    .output(z.array(ChecklistTemplateResponseSchema));
/**
 * PATCH /checklist-templates/{id}
 * Update a checklist template
 *
 * Express: PATCH /api/checklist-templates/:id
 */
export const updateChecklistTemplate = oc
    .route({
    method: "PATCH",
    path: "/checklist-templates/{id}",
    summary: "Update a checklist template",
    tags: ["ChecklistTemplates"],
})
    .input(z.object({ id: z.uuid() }).merge(UpdateChecklistTemplateInputSchema))
    .output(ChecklistTemplateResponseSchema);
/**
 * DELETE /checklist-templates/{id}
 * Delete a checklist template
 *
 * Express: DELETE /api/checklist-templates/:id
 */
export const deleteChecklistTemplate = oc
    .route({
    method: "DELETE",
    path: "/checklist-templates/{id}",
    summary: "Delete a checklist template",
    tags: ["ChecklistTemplates"],
    successStatus: 204,
})
    .input(z.object({ id: z.uuid() }))
    .output(z.void());
// ===== CONTRACT EXPORT =====
export const checklistTemplateContract = {
    create: createChecklistTemplate,
    get: getChecklistTemplate,
    list: getChecklistTemplates,
    update: updateChecklistTemplate,
    delete: deleteChecklistTemplate,
};
//# sourceMappingURL=checklistTemplate.js.map